(function () {
  'use strict';

  function esc(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function formatDate(iso) {
    if (!iso) return { display: '', machine: '' };
    var d = new Date(iso);
    if (isNaN(d.getTime())) return { display: '', machine: '' };
    return {
      display: MONTHS[d.getMonth()] + ' ' + pad2(d.getDate()) + ', ' + d.getFullYear(),
      machine: d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()),
    };
  }

  function getConfig(main) {
    var perPage = parseInt(main.getAttribute('data-sbap-per-page'), 10);
    var imageWidth = parseInt(main.getAttribute('data-sbap-image-width'), 10);
    return {
      shop: main.getAttribute('data-sbap-shop'),
      version: main.getAttribute('data-sbap-version') || '2024-10',
      token: main.getAttribute('data-sbap-token') || window.SF_API_TOKEN,
      blogHandle: main.getAttribute('data-sbap-blog-handle') || '',
      blogTitle: main.getAttribute('data-sbap-blog-title') || '',
      authorHandle: (main.getAttribute('data-sbap-author-handle') || '').trim().toLowerCase(),
      authorName: (main.getAttribute('data-sbap-author-name') || '').trim().toLowerCase(),
      perPage: Number.isInteger(perPage) && perPage > 0 ? perPage : 12,
      imageWidth: Number.isInteger(imageWidth) && imageWidth > 0 ? imageWidth : 900,
      showDate: main.getAttribute('data-sbap-show-date') === 'true',
      pageUrl: main.getAttribute('data-sbap-page-url') || window.location.pathname,
      pageParam: main.getAttribute('data-sbap-page-param') || 'author_page',
      prevLabel: main.getAttribute('data-sbap-prev-label') || '\u00ab Previous',
      nextLabel: main.getAttribute('data-sbap-next-label') || 'Next \u00bb',
    };
  }

  var ARTICLES_QUERY =
    'query SbapArticles($q: String!, $n: Int!, $after: String) {' +
    '  articles(first: $n, sortKey: PUBLISHED_AT, reverse: true, query: $q, after: $after) {' +
    '    edges { node {' +
    '      title handle onlineStoreUrl publishedAt' +
    '      image { url altText }' +
    '      authorV2 { name }' +
    '      authorRef: metafield(namespace: "custom", key: "author") {' +
    '        reference { ... on Metaobject { handle authorName: field(key: "name") { value } } }' +
    '      }' +
    '    } }' +
    '    pageInfo { hasNextPage endCursor }' +
    '  }' +
    '}';

  function matchesAuthor(node, config) {
    var ref = node.authorRef && node.authorRef.reference;
    var refHandle = ref && ref.handle ? String(ref.handle).trim().toLowerCase() : '';
    var refName = ref && ref.authorName && ref.authorName.value
      ? String(ref.authorName.value).trim().toLowerCase()
      : '';
    var nativeName = node.authorV2 && node.authorV2.name
      ? String(node.authorV2.name).trim().toLowerCase()
      : '';

    if (config.authorHandle && refHandle && refHandle === config.authorHandle) return true;
    if (config.authorName) {
      if (refName && refName === config.authorName) return true;
      if (nativeName && nativeName === config.authorName) return true;
    }
    return false;
  }

  var CACHE_TTL = 60 * 60 * 1000;

  function cacheKey(config) {
    return 'sbap:v1:' + config.blogHandle + ':' + (config.authorHandle || config.authorName);
  }

  function readCache(config) {
    try {
      var raw = window.localStorage.getItem(cacheKey(config));
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.articles)) return null;
      if (Date.now() - data.t > CACHE_TTL) return null;
      return data.articles;
    } catch (e) {
      return null;
    }
  }

  function writeCache(config, articles) {
    try {
      window.localStorage.setItem(cacheKey(config), JSON.stringify({ t: Date.now(), articles: articles }));
    } catch (e) {}
  }

  function sfRequest(config, query, variables) {
    if (window.StorefrontClient && typeof window.StorefrontClient.request === 'function') {
      return window.StorefrontClient.request(query, variables);
    }
    if (!config.shop || !config.token) return Promise.resolve(null);
    var endpoint = 'https://' + config.shop + '/api/' + config.version + '/graphql.json';
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': config.token },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) { return res.json(); })
      .catch(function () { return null; });
  }

  function fetchAuthorArticles(config) {
    var q = config.blogTitle ? "blog_title:'" + config.blogTitle.replace(/(['\\])/g, '\\$1') + "'" : '';
    var matched = [];

    function page(after, guard) {
      if (guard > 100) return Promise.resolve(matched);
      return sfRequest(config, ARTICLES_QUERY, { q: q, n: 100, after: after }).then(function (json) {
        var conn = json && json.data && json.data.articles;
        if (!conn) return guard === 0 ? null : matched;
        (conn.edges || []).forEach(function (edge) {
          var node = edge && edge.node;
          if (node && matchesAuthor(node, config)) matched.push(node);
        });
        var info = conn.pageInfo || {};
        if (info.hasNextPage && info.endCursor) return page(info.endCursor, guard + 1);
        return matched;
      });
    }

    return page(null, 0);
  }

  function imageMarkup(node, config) {
    if (!node.image || !node.image.url) {
      return '<span class="sbap-card__image-placeholder" aria-hidden="true"></span>';
    }
    var alt = node.image.altText || node.title || '';
    var widths = [400, 600, 800, 900];
    var srcset = widths
      .map(function (w) { return esc(withWidth(node.image.url, w)) + ' ' + w + 'w'; })
      .join(', ');
    return (
      '<img class="sbap-card__image" src="' + esc(withWidth(node.image.url, config.imageWidth)) + '"' +
      ' srcset="' + srcset + '" sizes="(min-width: 1025px) 33vw, (min-width: 769px) 50vw, 100vw"' +
      ' loading="lazy" alt="' + esc(alt) + '">'
    );
  }

  function dateMarkup(node, config) {
    if (!config.showDate) return '';
    var date = formatDate(node.publishedAt);
    if (!date.display) return '';
    return (
      '<p class="sbap-card__date"><time datetime="' + esc(date.machine) + '">' +
      esc(date.display) + '</time></p>'
    );
  }

  function cardMarkup(node, config) {
    var url = node.onlineStoreUrl || '/blogs/' + config.blogHandle + '/' + node.handle;
    var titleMarkup = node.title
      ? '<h2 class="sbap-card__title"><a href="' + esc(url) + '">' + esc(node.title) + '</a></h2>'
      : '';
    return (
      '<li class="sbap-grid__item"><article class="sbap-card">' +
      '<a href="' + esc(url) + '" class="sbap-card__media">' + imageMarkup(node, config) + '</a>' +
      '<div class="sbap-card__body">' +
      titleMarkup +
      dateMarkup(node, config) +
      '</div></article></li>'
    );
  }

  function pageHref(config, pageNum) {
    if (pageNum <= 1) return config.pageUrl;
    var sep = config.pageUrl.indexOf('?') > -1 ? '&' : '?';
    return config.pageUrl + sep + config.pageParam + '=' + pageNum;
  }

  function paginationRange(currentPage, totalPages, siblings) {
    siblings = siblings || 1;
    var maxNumbers = siblings * 2 + 5;
    var i;

    if (totalPages <= maxNumbers) {
      var all = [];
      for (i = 1; i <= totalPages; i++) all.push(i);
      return all;
    }

    var leftSibling = Math.max(currentPage - siblings, 1);
    var rightSibling = Math.min(currentPage + siblings, totalPages);
    var showLeftDots = leftSibling > 2;
    var showRightDots = rightSibling < totalPages - 1;
    var edgeCount = 3 + siblings * 2;
    var items = [];

    if (!showLeftDots && showRightDots) {
      for (i = 1; i <= edgeCount; i++) items.push(i);
      items.push('...');
      items.push(totalPages);
    } else if (showLeftDots && !showRightDots) {
      items.push(1);
      items.push('...');
      for (i = totalPages - edgeCount + 1; i <= totalPages; i++) items.push(i);
    } else {
      items.push(1);
      items.push('...');
      for (i = leftSibling; i <= rightSibling; i++) items.push(i);
      items.push('...');
      items.push(totalPages);
    }

    return items;
  }

  function pageItemMarkup(config, n, currentPage) {
    if (n === '...') {
      return (
        '<li class="sbap-pagination__item">' +
        '<span class="sbap-pagination__ellipsis" aria-hidden="true">\u2026</span></li>'
      );
    }
    if (n === currentPage) {
      return (
        '<li class="sbap-pagination__item">' +
        '<span class="sbap-pagination__link sbap-pagination__link--current" aria-current="page">' +
        n + '</span></li>'
      );
    }
    return (
      '<li class="sbap-pagination__item">' +
      '<a class="sbap-pagination__link" href="' + esc(pageHref(config, n)) + '" data-sbap-page="' + n +
      '" aria-label="Page ' + n + '">' + n + '</a></li>'
    );
  }

  function paginationMarkup(config, currentPage, totalPages) {
    if (totalPages <= 1) return '';
    var items = '';

    if (currentPage > 1) {
      items +=
        '<li class="sbap-pagination__item">' +
        '<a class="sbap-pagination__link sbap-pagination__link--nav" href="' +
        esc(pageHref(config, currentPage - 1)) + '" data-sbap-page="' + (currentPage - 1) + '" rel="prev">' +
        esc(config.prevLabel) + '</a></li>';
    }

    paginationRange(currentPage, totalPages, 1).forEach(function (n) {
      items += pageItemMarkup(config, n, currentPage);
    });

    if (currentPage < totalPages) {
      items +=
        '<li class="sbap-pagination__item">' +
        '<a class="sbap-pagination__link sbap-pagination__link--nav" href="' +
        esc(pageHref(config, currentPage + 1)) + '" data-sbap-page="' + (currentPage + 1) + '" rel="next">' +
        esc(config.nextLabel) + '</a></li>';
    }

    return '<ul class="sbap-pagination__list" role="list">' + items + '</ul>';
  }

  function getUrlPage(config) {
    var raw = Number(new URLSearchParams(window.location.search).get(config.pageParam));
    if (!Number.isInteger(raw) || raw < 1) return 1;
    return raw;
  }

  function render(main, config, articles, requestedPage, replaceUrl) {
    var grid = main.querySelector('[data-sbap-grid]');
    var nav = main.querySelector('[data-sbap-pagination]');
    var empty = main.querySelector('[data-sbap-empty]');

    if (!articles.length) {
      if (grid) grid.innerHTML = '';
      if (nav) { nav.hidden = true; nav.innerHTML = ''; }
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    var totalPages = Math.max(1, Math.ceil(articles.length / config.perPage));
    var currentPage = Math.max(1, Math.min(requestedPage || 1, totalPages));
    var start = (currentPage - 1) * config.perPage;
    var slice = articles.slice(start, start + config.perPage);

    if (grid) {
      grid.innerHTML = slice
        .map(function (node) { return cardMarkup(node, config); })
        .join('');
    }

    if (nav) {
      var markup = paginationMarkup(config, currentPage, totalPages);
      nav.innerHTML = markup;
      nav.hidden = !markup;
    }

    var params = new URLSearchParams(window.location.search);
    if (currentPage > 1) params.set(config.pageParam, String(currentPage));
    else params.delete(config.pageParam);
    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    var state = { sbapPage: currentPage };
    if (replaceUrl) window.history.replaceState(state, '', nextUrl);
    else window.history.pushState(state, '', nextUrl);

    main.dataset.sbapCurrentPage = String(currentPage);
  }

  function setLoading(main, isLoading) {
    var loader = main.querySelector('[data-sbap-loading]');
    var grid = main.querySelector('[data-sbap-grid]');
    var nav = main.querySelector('[data-sbap-pagination]');
    var empty = main.querySelector('[data-sbap-empty]');
    if (loader) loader.hidden = !isLoading;
    if (isLoading) {
      if (grid) grid.hidden = true;
      if (nav) nav.hidden = true;
      if (empty) empty.hidden = true;
      main.setAttribute('aria-busy', 'true');
    } else {
      if (grid) grid.hidden = false;
      main.removeAttribute('aria-busy');
    }
  }

  function setup(main, config, articles) {
    render(main, config, articles, getUrlPage(config), true);

    main.addEventListener('click', function (event) {
      var link = event.target.closest('[data-sbap-page]');
      if (!link || !main.contains(link)) return;
      event.preventDefault();
      var page = Number(link.getAttribute('data-sbap-page'));
      if (!Number.isInteger(page) || page < 1) return;
      render(main, config, articles, page, false);
      var top = main.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    window.addEventListener('popstate', function () {
      if (!document.body.contains(main)) return;
      render(main, config, articles, getUrlPage(config), true);
    });
  }

  function initMain(main) {
    if (!main || main.dataset.sbapBound === 'true') return;
    main.dataset.sbapBound = 'true';

    var config = getConfig(main);
    if (!config.blogTitle) return;
    if (!config.authorHandle && !config.authorName) return;

    var cached = readCache(config);
    if (cached) {
      setup(main, config, cached);
      return;
    }

    var hasClient = !!(window.StorefrontClient && window.StorefrontClient.request);
    if (!hasClient && (!config.shop || !config.token)) return;

    setLoading(main, true);

    fetchAuthorArticles(config)
      .then(function (articles) {
        setLoading(main, false);
        if (!articles) return;

        writeCache(config, articles);
        setup(main, config, articles);
      })
      .catch(function () {
        setLoading(main, false);
      });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sbap-main]').forEach(initMain);
    if (scope.matches && scope.matches('[data-sbap-main]')) initMain(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (root) boot(root);
  });
})();
